import { Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { EditClientModalComponent } from './edit-client-modal/edit-client-modal.component';

@Component({
  selector: 'app-client-manager',
  templateUrl: './client-manager.component.html',
  styleUrls: ['./client-manager.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ClientManagerComponent {

  @ViewChild(EditClientModalComponent) editClientModal!: EditClientModalComponent;

  // Handle client updated event
  onClientUpdated(): void {
    console.log('Client updated successfully!');
    // Any additional logic can be added here if needed
  }

  // Open add client modal
  openAddClientModal(): void {
    console.log('Opening add client modal');
    if (this.editClientModal) {
      this.editClientModal.openAddModal();
    }
  }

}
